var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-center-rail"},[(_vm.settingsNavSelected == 'text-log')?_c('sms-log'):_vm._e(),(_vm.settingsNavSelected == 'text-uniq-conv')?_c('conversations'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }